// extracted by mini-css-extract-plugin
export default {"rotateContainer":"rotatedevice_rotateContainer__+V5ZH","gifContainer":"rotatedevice_gifContainer__By0Lt","textContainer":"rotatedevice_textContainer__SsRxD"};